<div class="row">
  <div class="col-12">
    <p class="mb-0">{{ 'accountUi.welcomeBackUi.accountReactivated' | transloco }}</p>
  </div>
</div>
<button yat-button type="button" class="btn btn-secondary w-100" (click)="close()">{{ 'close' | commonWording | async }}</button>
